import store from "./../store/store";
let DashBoard = () => import("../pages/user/Dashboard");
let PurchaseHistory = () => import("../pages/user/PurchaseHistory");
let Downloads = () => import("../pages/user/Downloads");
let OrderDetails = () => import("../pages/user/OrderDetails");
let RefundRequests = () =>
    import("../pages/user/refund_request/RefundRequestList");
let RefundRequestCreate = () =>
    import("../pages/user/refund_request/RefundRequestCreate");
let Wishlist = () => import("../pages/user/Wishlist");
let Conversations = () => import("../pages/user/Conversations");
let ConversationDetails = () => import("../pages/user/ConversationDetails");
let FollowedShops = () => import("../pages/user/FollowedShops");
let Wallet = () => import("../pages/user/Wallet");
let EarningPoints = () => import("../pages/user/EarningPoints");
let Coupon = () => import("../pages/user/Coupon");
let Profile = () => import("../pages/user/Profile");
let UserLayout = () => import("../components/user/UserLayout");
let Error404 = () => import("../pages/errors/404");
export default [
    {
        path: "/user/",
        component: UserLayout,
        redirect: "/user/dashboard",
        children: [
            {
                path: "dashboard",
                component: DashBoard,
                name: "DashBoard",
                meta: { requiresAuth: true },
            },
            {
                path: "purchase-history",
                component: PurchaseHistory,
                name: "PurchaseHistory",
                meta: { requiresAuth: true },
            },
            {
                path: "downloads",
                component: Downloads,
                name: "Downloads",
                meta: { requiresAuth: true },
            },
            {
                path: "purchase-history/:code",
                component: OrderDetails,
                name: "OrderDetails",
                meta: { requiresAuth: true },
            },
            {
                path: "refund-requests",
                component: RefundRequests,
                name: "RefundRequests",
                meta: { requiresAuth: true },
            },
            {
                path: "create-refund-request/:orderId",
                component: RefundRequestCreate,
                name: "CreateRefundRequest",
                meta: { requiresAuth: true },
            },
            {
                path: "wishlist",
                component: Wishlist,
                name: "Wishlist",
                meta: { requiresAuth: true },
            },
            {
                path: "followed-shops",
                component: FollowedShops,
                name: "FollowedShops",
                meta: { requiresAuth: true },
            },

            {
                path: "product-query",
                component: Conversations,
                name: "Conversations",
                meta: { requiresAuth: true },
            },
            {
                path: "product-query/:slug",
                component: ConversationDetails,
                name: "ConversationsDetails",
                meta: { requiresAuth: true },
            },
            {
                path: "wallet",
                component: Wallet,
                name: "Wallet",
                meta: { requiresAuth: true },
            },

            {
                path: "earning-points",
                component: EarningPoints,
                name: "Earning",
                meta: { requiresAuth: true },
            },

            {
                path: "coupon",
                component: Coupon,
                name: "Coupon",
                meta: { requiresAuth: true },
            },
            {
                path: "profile",
                component: Profile,
                name: "Profile",
                meta: { requiresAuth: true },
            },
        ],
    },
];
